<template>
  <div class="paginator" v-if="all > 1">
    <div v-if="all > 3 && !onMobile" class="paginator__button paginator__button--control"
      v-on:click="previousRange()"
      v-bind:class="{ 'paginator__button--disabled': current <= 1 }">
      <svg>
        <use xlink:href="#icon-double-arrow-left"></use>
      </svg>
    </div>
    <div class="paginator__button paginator__button--control"
      v-on:click="previous()"
      v-bind:class="{ 'paginator__button--disabled': current <= 1 }">
      <svg>
        <use xlink:href="#icon-angle-pointing-left"></use>
      </svg>
    </div>
    <div class="paginator__button paginator__button--page"
      v-on:click="go(page)"
      v-for="page in range"
      v-bind:key="page"
      v-bind:class="{ 'paginator__button--active': page === current }">
      {{ page }}
    </div>
    <div class="paginator__button paginator__button--control"
      v-on:click="next()"
      v-bind:class="{ 'paginator__button--disabled': current >= all }">
      <svg>
        <use xlink:href="#icon-angle-pointing-right"></use>
      </svg>
    </div>
    <div v-if="all > 3 && !onMobile" class="paginator__button paginator__button--control"
      v-on:click="nextRange()"
      v-bind:class="{ 'paginator__button--disabled': current >= all }">
      <svg>
        <use xlink:href="#icon-double-arrow-right"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'nt-paginator',
  props: {
    total: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 0
      }
    },
    current: {
      type: Number,
      required: true,
      validator(value) {
        return value > 0
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    limit: {
      type: Number,
      required: false,
      default: 5
    }
  },
  model: {
    prop: 'current',
    event: 'paginate'
  },
  data() {
    return {
      onMobile: false,
      pageLimit: this.limit
    }
  },
  watch: {
    onMobile(value) {
      if (value) {
        this.pageLimit = 3
      }
    }
  },
  computed: {
    all() {
      return Math.ceil(this.total / this.pageSize)
    },
    pages() {
      const pages = []

      for (let page = 1; page <= this.all; page += 1) {
        pages.push(page)
      }

      return pages
    },
    range() {
      let dif = Math.floor(this.pageLimit / 2)

      let start = (this.current - 1) - dif

      if (start < 1) {
        dif += Math.abs(start)
        start = 0
      }

      let end = this.current + dif

      if (end > this.all) {
        start -= (end - this.all)
        end = this.all
      }

      if (start < 1) start = 0

      return this.pages.slice(start, end)
    }
  },
  created() {
    this.onMobile = this.isOnMobile()
  },
  methods: {
    ...mapActions([
      'changePage'
    ]),
    isOnMobile() {
      return (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
      )
    },
    previousRange() {
      if (this.current > 1) {
        this.changePage(1)
        this.$emit('paginate', 1)
      }
    },
    previous() {
      if (this.current > 1) {
        const next = this.current - 1
        this.changePage(next)
        this.$emit('paginate', next)
      }
    },
    go(page) {
      this.changePage(page)
      this.$emit('paginate', page)
    },
    next() {
      if (this.current < this.all) {
        const next = this.current + 1
        this.changePage(next)
        this.$emit('paginate', next)
      }
    },
    nextRange() {
      if (this.current < this.all) {
        this.changePage(this.all)
        this.$emit('paginate', this.all)
      }
    }
  }
}
</script>
